import React, { useState } from 'react';
import { ChevronDown, ChevronUp, FileText, Download, Eye } from 'lucide-react';
import { BASE_URL } from '@/lib/API';

export const InitialQuotationAccordion = ({ lead }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!lead) {
    return null;
  }

  const iqData = lead.initialQuotationData || {};
  const hasData = !!iqData._id && iqData.status !== 'Draft' && !!iqData.quotationNo && iqData.quotationNo !== '-';

  return (
    <div className="bg-emerald-50/40 rounded-xl border border-emerald-100/60 overflow-hidden">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-emerald-50/60 transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="text-[10px] text-emerald-600 font-bold uppercase tracking-wider flex items-center gap-2">
          <span className="w-1 h-3 bg-emerald-500 rounded-full" />
          Initial Quotation {hasData ? `Available (${iqData.quotationNo})` : 'Not Available'}
        </div>
        <div className="flex items-center gap-3">
          {isOpen ? <ChevronUp size={16} className="text-emerald-400" /> : <ChevronDown size={16} className="text-emerald-400" />}
        </div>
      </div>
      
      {isOpen && (
        <div className="px-4 pb-4 border-t border-emerald-100/50 pt-3">
          {hasData ? (
            <div className="flex flex-col gap-3">
              <div className="border border-slate-200 bg-white rounded p-3">
                <h5 className="text-[11px] font-bold text-slate-600 mb-2 border-b pb-1">Quotation Details</h5>
                <div className="flex flex-col gap-2">
                  <div className="text-[11px] text-slate-500 bg-slate-50 p-2 rounded flex flex-col gap-1">
                    <div><span className="font-semibold text-slate-700">Project Name:</span> {iqData.projectName || '-'}</div>
                    <div><span className="font-semibold text-slate-700">Designer:</span> {iqData.designer || iqData.referenceDesigner || '-'}</div>
                    <div><span className="font-semibold text-slate-700">Amount:</span> {iqData.totals?.grandTotal || '₹0'}</div>
                  </div>
                </div>
              </div>
              
              {iqData.pdfFileId && (
                <div className="mt-1 border border-slate-200 bg-white rounded p-3">
                  <h5 className="text-[11px] font-bold text-slate-600 mb-2 border-b pb-1">Attached PDF</h5>
                  <div className="flex flex-col gap-1.5">
                    <div 
                      className="flex items-center gap-2 text-[11px] text-emerald-600 bg-slate-50 p-2 rounded border border-slate-100 transition-colors w-full text-left group hover:bg-slate-100"
                    >
                      <FileText size={14} className="text-red-500 shrink-0" />
                      <span className="truncate flex-1">Quotation_{iqData.quotationNo || Date.now()}.pdf</span>
                      
                      <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            const url = iqData.pdfUrl ? `${BASE_URL}${iqData.pdfUrl}` : `${BASE_URL}/api/inventory/budget/${iqData._id}/pdf`;
                            window.open(url, '_blank');
                          }}
                          className="w-7 h-7 rounded-md bg-white flex items-center justify-center text-slate-400 hover:text-brand-blue transition-all border border-slate-100 shadow-sm"
                          title="Preview"
                        >
                          <Eye size={12} />
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            import('@/lib/API').then(({ downloadFile }) => {
                              const url = iqData.pdfUrl ? `${BASE_URL}${iqData.pdfUrl}` : `${BASE_URL}/api/inventory/budget/${iqData._id}/pdf`;
                              downloadFile(url, `Quotation_${iqData.quotationNo || Date.now()}.pdf`);
                            });
                          }}
                          className="w-7 h-7 rounded-md bg-white flex items-center justify-center text-slate-400 hover:text-emerald-600 transition-all border border-slate-100 shadow-sm"
                          title="Download"
                        >
                          <Download size={12} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="text-[11px] text-slate-500 italic text-center py-2">
              No initial quotation has been generated yet.
            </div>
          )}
        </div>
      )}
    </div>
  );
};
